module.exports = __webpack_public_path__ + "assets/img/ynfour.347e943d.png";